module.exports = __webpack_public_path__ + "img/dvsc.4ff17a52.png";